import styled from "styled-components";

export const ProfilePic = styled.img`
  display: inline-block;
  height: 40px;
  width: 40px;
  margin-right: 10px;
  border-radius: 50%;
`;